<template>
  <div class="box-sin-aplicar-3">
    <div style="background-color: yellow;">T.Amarilla # {{ item.orden }}</div>
    <div><b>Etapa:</b> {{ item.etapa }} <b>Fecha #: </b>{{ item.num_fecha }}</div>
    <div><b>Fecha: </b>{{ item.fecha }}</div>
    <div style="font-size:12px; text-transform: uppercase;">
      {{ item.local }} vs {{ item.visita }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: Object,
    label: String,
  },
}
</script>
<style lang="scss">
.box-sin-aplicar-3 {
  background-color: rgb(248, 244, 244);
  width: 100%;
  height: 95px;
  margin: 5px;
  padding: 3px;
  border-radius: 4px;
  display: block;
  font-size: 13px;
}
</style>
